import dayjs from 'dayjs';

export default {
  namespaced: true,

  state: {
    localTimezone: '',
    actualChoosenTimezone: '',
    lastChoosenTimezone: {
      users: [],
    },
  },

  getters: {
    localTimezone(state) {
      return state.localTimezone;
    },

    choosenTimezone(state) {
      return state.actualChoosenTimezone;
    },

    lastChoosenTimezone(state, getters) {
      return state.lastChoosenTimezone.users
        .find((user) => user.id === getters.user.id);
    },

    checkLastChoosenTimezone(state, getters) {
      return !getters.lastChoosenTimezone
       || getters.lastChoosenTimezone.localTimezone !== getters.localTimezone;
    },

    checkUserDefaultTimezone(state, getters) {
      return getters.user.timezone !== null && getters.user.timezone !== getters.localTimezone;
    },

    user(state, getters, rootState, rootGetters) {
      return rootGetters['auth/user'];
    },
  },

  mutations: {
    SET_LAST_CHOOSEN_TIMEZONE(state, userId) {
      const userTimezoneData = state.lastChoosenTimezone.users.find((user) => user.id === userId);
      if (!userTimezoneData) {
        const user = {
          id: userId,
          localTimezone: state.localTimezone,
          choosenTimezone: state.actualChoosenTimezone,
        };
        state.lastChoosenTimezone.users.push(user);
        return;
      }
      userTimezoneData.localTimezone = state.localTimezone;
      userTimezoneData.choosenTimezone = state.actualChoosenTimezone;
    },

    SET_LOCAL_TIMEZONE(state) {
      state.localTimezone = dayjs.tz.guess();
    },

    SET_CHOOSEN_TIMEZONE(state, choosenTimezone) {
      state.actualChoosenTimezone = choosenTimezone;
    },
  },

  actions: {
    setLastChoosenTimezone({ commit }, userId) {
      commit('SET_LAST_CHOOSEN_TIMEZONE', userId);
    },

    setChoosenTimezone({ commit }, choosenTimezone) {
      commit('SET_CHOOSEN_TIMEZONE', choosenTimezone);
    },

    setLocalTimezone({ commit }) {
      commit('SET_LOCAL_TIMEZONE');
    },

  },
};
